/**
 * Documentation content wrapper component
 */

import {ReactNode} from 'react';

interface DocsContentProps {
  children: ReactNode;
  title?: string;
  description?: string;
}

export function DocsContent({children, title, description}: DocsContentProps) {
  return (
    <div className="px-8 py-12 bg-background dark:bg-[#1E1E1E] min-h-screen">
      {title && (
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-textPrimary dark:text-[#CCCCCC] mb-4">{title}</h1>
          {description && <p className="text-lg text-textSecondary dark:text-[#858585] leading-relaxed">{description}</p>}
        </div>
      )}
      <div className="prose prose-sm prose-gray dark:prose-invert max-w-none prose-headings:text-textPrimary dark:prose-headings:text-[#CCCCCC] prose-p:text-textSecondary dark:prose-p:text-[#858585] prose-a:text-accent dark:prose-a:text-orange-500 prose-strong:text-textPrimary dark:prose-strong:text-[#CCCCCC] prose-code:text-textPrimary dark:prose-code:text-[#CCCCCC] prose-code:bg-gray-100 dark:prose-code:bg-[#252526] prose-pre:bg-gray-900 dark:prose-pre:bg-[#1E1E1E]">
        {children}
      </div>
    </div>
  );
}

